module.exports = __webpack_public_path__ + "static/media/resume-tilaksharma.83e25648.docx";


//////////////////
// WEBPACK FOOTER
// ./src/components/resume-tilaksharma.docx
// module id = 344
// module chunks = 0